import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import styles from "./PreviewItem.module.css";
import ImageCarousel from "../ImageCarousel/ImageCarousel";

export default function PreviewItem({
  imgRight,
  header,
  description,
  imgs,
  children,
  footer,
}) {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        {imgRight && (
          <div className={styles.textColumn}>
            <h3>{header}</h3>
            {typeof description === "string" ? (
              <p>{description}</p>
            ) : (
              <div className={styles.description}>{description}</div>
            )}

            <div>{children}</div>
          </div>
        )}
        {imgs.length === 1 ? (
          <div className={styles.imageColumn}>
            <img
              className={styles.image}
              src={require(`../../assets/${imgs[0].src}`)}
              alt={imgs[0].alt}
            />
          </div>
        ) : (
          <div className={styles.imageColumn}>
            <ImageCarousel className={styles.image} imgs={imgs} />
          </div>
        )}
        {!imgRight && (
          <div className={styles.textColumn}>
            <h3>{header}</h3>
            {typeof description === "string" ? (
              <p>{description}</p>
            ) : (
              <div className={styles.description}>{description}</div>
            )}

            <div>{children}</div>
          </div>
        )}
      </div>
      {footer && <div className={styles.footer}>{footer}</div>}
    </div>
  );
}

PreviewItem.propTypes = {
  imgRight: PropTypes.bool,
  header: PropTypes.string,
  description: PropTypes.node,
  imgs: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string,
      alt: PropTypes.string,
    })
  ).isRequired,
  children: PropTypes.node,
  footer: PropTypes.node,
};
